import Reflux from "reflux";
import GdprStorage from "../storage/GdprStorage";
export function createCartMetaStore(key: string): Reflux.Store {
	const CART_ID_KEY = key + "Id";
	const CART_STORE_KEY = key + "Store";
	return Reflux.createStore({
		init: function () {
			this.localstorage = GdprStorage.localStorage;
		},
		get: function (key: string): string | null {
			return this.localstorage.read(key) || null;
		},
		set: function (key: string, value: string | null) {
			if (value !== this.get(key)) {
				if (value == null) {
					this.localstorage.remove(key);
				} else {
					this.localstorage.put(key, value, GdprStorage.NECESSARY);
				}

				this.trigger();
			}
		},
		setCartId: function (id: string | null) {
			this.set(CART_ID_KEY, id);
		},
		getCartId: function (): string | null {
			return this.get(CART_ID_KEY);
		},
		setStoreId: function (id: string) {
			this.set(CART_STORE_KEY, id);
		},
		getStoreId: function (): string | null {
			return this.get(CART_STORE_KEY);
		},
		// deprecated
		getAnonymousCartId: function (): string | null {
			return this.getCartId();
		},
		// deprecated
		setAnonymousCartId: function (id: string | null) {
			this.setCartId(id);
		},
	});
}
export const AnonymousCartMetaStore = createCartMetaStore("anonymousCart") as Reflux.Store;
export const CustomerCartMetaStore = createCartMetaStore("customerCart") as Reflux.Store;
